/**
 * The practice the signed-in user belongs to.
 *
 * GET /auth/me returns it under `scope.practice_id` (ADR-0004) and may omit the
 * legacy top-level `practice_id`, so prefer the scope and fall back to the top level.
 */
export function getPracticeId(
  user: { scope?: { practice_id?: string | null } | null; practice_id?: string | null } | null | undefined
): string | null {
  return user?.scope?.practice_id ?? user?.practice_id ?? null;
}
